// Recovered compiled webpack factory 75040. Edit this function expression; run npm run build.
(e, t, r) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "getImgProps", {
      enumerable: !0,
      get: function () {
        return s;
      },
    }),
    r(94781));
  let n = r(14105),
    i = r(20821),
    o = ["-moz-initial", "fill", "none", "scale-down", void 0];
  function a(e) {
    return void 0 !== e.default;
  }
  function l(e) {
    return void 0 === e
      ? e
      : "number" == typeof e
        ? Number.isFinite(e)
          ? e
          : NaN
        : "string" == typeof e && /^[0-9]+$/.test(e)
          ? parseInt(e, 10)
          : NaN;
  }
  function s(e, t) {
    var r, s;
    let d,
      u,
      f,
      {
        src: c,
        sizes: p,
        unoptimized: g = !1,
        priority: m = !1,
        loading: h,
        className: b,
        quality: y,
        width: v,
        height: _,
        fill: w = !1,
        style: j,
        overrideSrc: x,
        onLoad: S,
        onLoadingComplete: C,
        placeholder: O = "empty",
        blurDataURL: P,
        fetchPriority: E,
        decoding: R = "async",
        layout: z,
        objectFit: M,
        objectPosition: I,
        lazyBoundary: D,
        lazyRoot: k,
        ...A
      } = e,
      { imgConf: N, showAltText: L, blurComplete: T, defaultLoader: F } = t,
      U = N || i.imageConfigDefault;
    if ("allSizes" in U) d = U;
    else {
      let e = [...U.deviceSizes, ...U.imageSizes].sort((e, t) => e - t),
        t = U.deviceSizes.sort((e, t) => e - t),
        n = null == (r = U.qualities) ? void 0 : r.sort((e, t) => e - t);
      d = { ...U, allSizes: e, deviceSizes: t, qualities: n };
    }
    if (void 0 === F)
      throw Object.defineProperty(
        Error(
          "images.loaderFile detected but the file is missing default export.\nRead more: https://nextjs.org/docs/messages/invalid-images-config",
        ),
        "__NEXT_ERROR_CODE",
        { value: "E163", enumerable: !1, configurable: !0 },
      );
    let B = A.loader || F;
    (delete A.loader, delete A.srcSet);
    let G = "__next_img_default" in B;
    if (G) {
      if ("custom" === d.loader)
        throw Object.defineProperty(
          Error(
            'Image with src "' +
              c +
              '" is missing "loader" prop.\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader',
          ),
          "__NEXT_ERROR_CODE",
          { value: "E252", enumerable: !1, configurable: !0 },
        );
    } else {
      let e = B;
      B = (t) => {
        let { config: r, ...n } = t;
        return e(n);
      };
    }
    if (z) {
      "fill" === z && (w = !0);
      let e = {
        intrinsic: { maxWidth: "100%", height: "auto" },
        responsive: { width: "100%", height: "auto" },
      }[z];
      e && (j = { ...j, ...e });
      let t = { responsive: "100vw", fill: "100vw" }[z];
      t && !p && (p = t);
    }
    let q = "",
      V = l(v),
      W = l(_);
    if ((s = c) && "object" == typeof s && (a(s) || void 0 !== s.src)) {
      let e = a(c) ? c.default : c;
      if (!e.src)
        throw Object.defineProperty(
          Error(
            "An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received " +
              JSON.stringify(e),
          ),
          "__NEXT_ERROR_CODE",
          { value: "E460", enumerable: !1, configurable: !0 },
        );
      if (!e.height || !e.width)
        throw Object.defineProperty(
          Error(
            "An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received " +
              JSON.stringify(e),
          ),
          "__NEXT_ERROR_CODE",
          { value: "E48", enumerable: !1, configurable: !0 },
        );
      if (((u = e.blurWidth), (f = e.blurHeight), (P = P || e.blurDataURL), (q = e.src), !w))
        if (V || W) {
          if (V && !W) {
            let t = V / e.width;
            W = Math.round(e.height * t);
          } else if (!V && W) {
            let t = W / e.height;
            V = Math.round(e.width * t);
          }
        } else ((V = e.width), (W = e.height));
    }
    let H = !m && ("lazy" === h || void 0 === h);
    ((!(c = "string" == typeof c ? c : q) || c.startsWith("data:") || c.startsWith("blob:")) &&
      ((g = !0), (H = !1)),
      d.unoptimized && (g = !0),
      G && !d.dangerouslyAllowSVG && c.split("?", 1)[0].endsWith(".svg") && (g = !0));
    let X = l(y),
      Y = Object.assign(
        w
          ? {
              position: "absolute",
              height: "100%",
              width: "100%",
              left: 0,
              top: 0,
              right: 0,
              bottom: 0,
              objectFit: M,
              objectPosition: I,
            }
          : {},
        L ? {} : { color: "transparent" },
        j,
      ),
      $ =
        T || "empty" === O
          ? null
          : "blur" === O
            ? 'url("data:image/svg+xml;charset=utf-8,' +
              (0, n.getImageBlurSvg)({
                widthInt: V,
                heightInt: W,
                blurWidth: u,
                blurHeight: f,
                blurDataURL: P || "",
                objectFit: Y.objectFit,
              }) +
              '")'
            : 'url("' + O + '")',
      J = o.includes(Y.objectFit) ? ("fill" === Y.objectFit ? "100% 100%" : "cover") : Y.objectFit,
      K = $
        ? {
            backgroundSize: J,
            backgroundPosition: Y.objectPosition || "50% 50%",
            backgroundRepeat: "no-repeat",
            backgroundImage: $,
          }
        : {},
      Q = (function (e) {
        let { config: t, src: r, unoptimized: n, width: i, quality: o, sizes: a, loader: l } = e;
        if (n) return { src: r, srcSet: void 0, sizes: void 0 };
        let { widths: s, kind: d } = (function (e, t, r) {
            let { deviceSizes: n, allSizes: i } = e;
            if (r) {
              let e = /(^|\s)(1?\d?\d)vw/g,
                t = [];
              for (let n; (n = e.exec(r)); ) t.push(parseInt(n[2]));
              if (t.length) {
                let e = 0.01 * Math.min(...t);
                return { widths: i.filter((t) => t >= n[0] * e), kind: "w" };
              }
              return { widths: i, kind: "w" };
            }
            return "number" != typeof t
              ? { widths: n, kind: "w" }
              : {
                  widths: [
                    ...new Set([t, 2 * t].map((e) => i.find((t) => t >= e) || i[i.length - 1])),
                  ],
                  kind: "x",
                };
          })(t, i, a),
          u = s.length - 1;
        return {
          sizes: a || "w" !== d ? a : "100vw",
          srcSet: s
            .map(
              (e, n) =>
                l({ config: t, src: r, quality: o, width: e }) + " " + ("w" === d ? e : n + 1) + d,
            )
            .join(", "),
          src: l({ config: t, src: r, quality: o, width: s[u] }),
        };
      })({ config: d, src: c, unoptimized: g, width: V, quality: X, sizes: p, loader: B });
    return {
      props: {
        ...A,
        loading: H ? "lazy" : h,
        fetchPriority: E,
        width: V,
        height: W,
        decoding: R,
        className: b,
        style: { ...Y, ...K },
        sizes: Q.sizes,
        srcSet: Q.srcSet,
        src: x || Q.src,
      },
      meta: { unoptimized: g, priority: m, placeholder: O, fill: w },
    };
  }
}
